// FILE: src/features/nmck-calculator/components/typical-nmck-chip.tsx
// VERSION: 1.0.0
// START_MODULE_CONTRACT:
// // PURPOSE: Компактный бейдж «типовая НМЦК региона ≈X ₽/мес» для сетки городов и региональных страниц.
// // SCOPE: Серверный компонент (без "use client") — вычисляет типовой расчёт из переданных данных региона.
// // INPUT: region { mrot_value, regional_coef, north_coef } — данные региона из nmck_regions.
// // OUTPUT: JSX-бейдж с типовой НМЦК региона в ₽/мес.
// // KEYWORDS: DOMAIN(НМЦК): TypicalCalc; TECH(React): ServerComponent; UI(Design): DarkMono
// // LINKS: FORMULA(lib/typical-nmck.ts): calculateTypicalNmck; READS_DATA_FROM(nmck_regions): данные региона
// // END_MODULE_CONTRACT

// START_CHANGE_SUMMARY:
// LAST_CHANGE: 1.0.0 — Initial implementation.
// END_CHANGE_SUMMARY

import type { NmckRegion } from "../actions/regions";
import { calculateTypicalNmck, formatTypicalNmck } from "../lib/typical-nmck";

// START_CONTRACT:
// PURPOSE: Бейдж «типовая НМЦК ≈X ₽/мес» для переданного региона.
// INPUTS: region — { mrot_value, regional_coef, north_coef }; prefix — подпись перед значением.
// OUTPUTS: JSX.
// COMPLEXITY_SCORE: 1
// END_CONTRACT
export function TypicalNmckChip({
  region,
  prefix = "типовая НМЦК",
}: {
  region: Pick<NmckRegion, "mrot_value" | "regional_coef" | "north_coef">;
  prefix?: string;
}) {
  const value = calculateTypicalNmck(region);
  return (
    <span className="block mt-1 text-[10px] text-[hsl(var(--portal-text-muted))] font-mono tabular-nums">
      {prefix} ≈{formatTypicalNmck(value)}
    </span>
  );
}

// START_CONTRACT:
// PURPOSE: Тот же бейдж для случаев, когда значение уже предвычислено (статические SEO-страницы).
// INPUTS: value — типовой расчёт в ₽/мес; prefix — подпись перед значением.
// OUTPUTS: JSX.
// COMPLEXITY_SCORE: 1
// END_CONTRACT
export function TypicalNmckValueChip({
  value,
  prefix = "типовая НМЦК",
}: {
  value: number;
  prefix?: string;
}) {
  return (
    <span className="block mt-1 text-[10px] text-[hsl(var(--portal-text-muted))] font-mono tabular-nums">
      {prefix} ≈{formatTypicalNmck(value)}
    </span>
  );
}
